{
  "close": "关闭"
}
